"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _logger = require("@insided/shared/services/logger");

var _axios = _interopRequireDefault(require("axios"));

var _preactCompat = require("preact-compat");

var _DropdownControl = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownControl"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _CrmAccountValuesSelector = _interopRequireDefault(require("./CrmAccountValuesSelector"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CrmImportInputFields = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(CrmImportInputFields, _PureComponent);

  var _super = _createSuper(CrmImportInputFields);

  function CrmImportInputFields(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CrmImportInputFields);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "wrapperRef", null);
    _this.state = {
      fields: [],
      values: [],
      isLoading: false,
      selectedField: null,
      selectedValues: [],
      isValueDropdownOpen: false
    };
    _this.addHandler = _this.addHandler.bind((0, _assertThisInitialized2.default)(_this));
    _this.removeHandler = _this.removeHandler.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClickOutside = _this.handleClickOutside.bind((0, _assertThisInitialized2.default)(_this));
    _this.toggleDropdown = _this.toggleDropdown.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleResetValuesDropdown = _this.handleResetValuesDropdown.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleApplySelectedValues = _this.handleApplySelectedValues.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(CrmImportInputFields, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this$props, fieldApiName, valueApiName, _yield$axios$get, data, selectedField, values, selectedValues;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, fieldApiName = _this$props.fieldApiName, valueApiName = _this$props.valueApiName;
                this.setState({
                  isLoading: true
                });
                _context.prev = 2;
                _context.next = 5;
                return _axios.default.get('/integration/salesforce/accountPicklistFields');

              case 5:
                _yield$axios$get = _context.sent;
                data = _yield$axios$get.data;
                selectedField = data.find(function (field) {
                  return field.value.toLowerCase() === fieldApiName.toLowerCase();
                });
                values = (selectedField === null || selectedField === void 0 ? void 0 : selectedField.values) || [];
                selectedValues = valueApiName || [];
                this.setState({
                  selectedField: selectedField,
                  selectedValues: selectedValues,
                  fields: data,
                  values: values,
                  isLoading: false
                });
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](2);

                _logger.logger.error(_context.t0, {
                  component: 'CrmImportInputFields',
                  action: 'fetchFields'
                });

                this.setState({
                  isLoading: false
                });

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 13]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "addHandler",
    value: function addHandler() {
      var isValueDropdownOpen = this.state.isValueDropdownOpen;

      if (isValueDropdownOpen) {
        window.document.addEventListener('mousedown', this.handleClickOutside);
      }
    }
  }, {
    key: "removeHandler",
    value: function removeHandler() {
      window.document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(e) {
      if (!this.wrapperRef) return;

      if (!this.wrapperRef.contains(e.target)) {
        this.setState({
          isValueDropdownOpen: false
        }, this.removeHandler);
      }
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown(value) {
      this.setState({
        isValueDropdownOpen: value
      }, this.addHandler);
    }
  }, {
    key: "handleResetValuesDropdown",
    value: function handleResetValuesDropdown() {
      this.setState({
        isValueDropdownOpen: false
      });
    }
  }, {
    key: "handleApplySelectedValues",
    value: function handleApplySelectedValues(selectedItems) {
      this.setState({
        isValueDropdownOpen: false,
        selectedValues: selectedItems
      });
      this.props.onCrmImportMappingPicklistValueChanged(selectedItems);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          selectedField = _this$state.selectedField,
          selectedValues = _this$state.selectedValues,
          isValueDropdownOpen = _this$state.isValueDropdownOpen,
          fields = _this$state.fields;
      var accountFieldItems = fields ? fields.map(function (field) {
        return {
          title: field.label,
          value: field.value,
          onClick: function onClick() {
            var selectedField = _this2.state.selectedField;

            if ((selectedField === null || selectedField === void 0 ? void 0 : selectedField.value.toLowerCase()) !== field.value.toLowerCase()) {
              _this2.setState({
                selectedField: field,
                selectedValues: []
              });

              _this2.props.onCrmImportMappingFieldApiNameChanged(field.value);
            }
          }
        };
      }) : [];
      var accountValuesItems = selectedField ? selectedField.values.map(function (field) {
        return {
          id: field.value,
          name: field.label,
          value: field.value
        };
      }) : [];
      return (0, _preact.h)("div", null, (0, _preact.h)("div", {
        className: "panel-input-dropdown-container integrations-crm-field-selector"
      }, (0, _preact.h)("div", {
        className: "crm-field-category-label"
      }, "Account field"), (0, _preact.h)("div", {
        className: "crm-field-category-meta"
      }, "Choose a field where you store data about whether an Account is a customer in your Salesforce instance. Only Account fields with type \u2018Picklist\u2019 are currently supported."), (0, _preact.h)("div", {
        className: "form-group"
      }, (0, _preact.h)(_DropdownControl.default, {
        closeOnDropdownClick: true,
        className: "",
        triggerClass: "crm-field-selector-trigger",
        align: "adjust",
        searchPlaceholderText: "Search for account field",
        trigger: function trigger(isTriggerOpen) {
          var _selectedField$label;

          return (0, _preact.h)(_Button.default, {
            title: (_selectedField$label = selectedField === null || selectedField === void 0 ? void 0 : selectedField.label) !== null && _selectedField$label !== void 0 ? _selectedField$label : 'Select Account field',
            className: "integrations-salesforce_field-selector".concat(isTriggerOpen ? ' crm-field-selector-is-open' : ''),
            icon: "chevronDown"
          });
        },
        items: accountFieldItems,
        hasSearch: true,
        newStyle: true,
        searchIconHeight: 16,
        searchIconWidth: 16
      }))), ((selectedField === null || selectedField === void 0 ? void 0 : selectedField.label) || (selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.length) > 0) && (0, _preact.h)("div", {
        className: "panel-input-dropdown-container integrations-crm-field-selector"
      }, (0, _preact.h)("div", {
        className: "crm-field-category-label"
      }, "Values"), (0, _preact.h)("div", {
        className: "crm-field-category-meta"
      }, "Choose one or more values that identify customer Accounts in your Salesforce instance."), (0, _preact.h)("div", {
        className: "form-group",
        ref: function ref(node) {
          return _this2.wrapperRef = node;
        }
      }, (0, _preact.h)(_CrmAccountValuesSelector.default, {
        isLoading: false,
        id: "Values",
        name: "Values",
        title: "Select Values",
        isDropdownOpen: isValueDropdownOpen,
        toggleDropdown: this.toggleDropdown,
        resetDropdown: this.handleResetValuesDropdown,
        onChange: this.handleApplySelectedValues,
        items: accountValuesItems,
        selectedItems: selectedValues,
        selectedField: selectedField
      }))));
    }
  }]);
  return CrmImportInputFields;
}(_preactCompat.PureComponent);

exports.default = CrmImportInputFields;